import CertifyIcon from '#app/components/icons/Miscellaneous/CertifyIcon'

export default {
	name: 'Collection',
	slug: 'collection',
	version: '1.0.0',
	icon: CertifyIcon,
	fields: [
		{
			name: 'Name',
			slug: 'name',
			required: true,
			type: 'text',
			placeholder: "The Collection's Name",
		},
		{
			name: 'Slug',
			slug: 'slug',
			required: true,
			type: 'text',
			placeholder: "The Collection's slug",
			hidden: false,
		},
		{
			name: 'Description',
			slug: 'description',
			required: true,
			type: 'text',
			placeholder: "The Collection's Description",
		},
		{
			name: 'URL',
			slug: 'url',
			required: false,
			type: 'text',
			placeholder: "The Collection's External Link",
		},
		{
			name: 'Image URL',
			slug: 'imageUrl',
			required: true,
			type: 'text',
			placeholder: "The Collection's Image URL",
		},
		{
			name: 'Date',
			slug: 'date',
			required: false,
			type: 'date',
			placeholder: "The Collection's Date",
		},
		{
			name: 'NFTs',
			slug: 'nfts',
			required: true,
			type: 'collectionNFTs',
			placeholder: "The Collection's NFTs",
		},
		{
			name: 'Group NFTs CID',
			slug: 'GroupNFTsCID',
			required: false,
			hidden: true,
			type: 'string',
			placeholder: "The Collection's NFTs CID",
		},
		{
			name: 'Marketplace URLs',
			slug: 'marketplaceUrls',
			required: false,
			hidden: true,
			type: 'string',
			placeholder: "The Collection's Marketplace URLs",
		},
		{
			name: 'Artist',
			slug: 'artistID',
			required: false,
			hidden: true,
			type: 'string',
			placeholder: "The Collection's Artist's Atomic Lore Account",
		},
		{
			name: 'Artist Name',
			slug: 'artistName',
			required: false,
			hidden: true,
			type: 'string',
			placeholder: "The Collection's Artist's Name",
		},
		{
			name: 'Artist Picture',
			slug: 'artistAvatar',
			required: false,
			hidden: true,
			type: 'string',
			placeholder: "The Collection's Artist's Picture",
		},
	],
	info: 'https://atomicform.com/faq',
}
